import styled from 'styled-components';
import { COLOR } from '../../assets/constants/constants'

const StyledDiv = styled.div`
  width: 85%;
  padding-left: 13%;
  padding-top: 2em;
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;

  @media (max-width: 600px) {
    width: 90%;
    padding-left: 5%;
    padding-top: ${p => p.paddingTop !== null ? p.paddingTop : '1.6em'};
  }

  @media (min-width: 768px) {
    padding-top: 0;
  }

  @media (min-width: 768px) and (max-height: 700px){
    padding-top: 0;
  }
`;

const StyleFirstRow =  styled.div`
  display: flex;
  border-top: 1px solid #112426;
  margin: 20px 0;
  padding-top: 5px;
  margin-bottom: 1em;
  justify-content: space-between;
  p {
    color: #BBC3C3;
    margin-top: none;
    margin-bottom: none;
  }
  img {
    height: 30px;
    width: auto;
  }

  @media (min-width: 768px) and (max-height: 700px){
    margin: 10px 0 8px 0;
  }
`;

const StyledLogo = styled.img`
  position: relative;
`;

const StyledButton = styled.div`
  display: flex;
  height: 25px;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  color: ${p => p.active ? COLOR.secondary : '#BBC3C3' };

  p {
    margin-top: 17px;
    padding: 5px;
    color: ${p => p.active ? COLOR.secondary : '#BBC3C3' };
  };

  &:hover {
    fill: #1D3739;
    color: #1D3739;

    svg {
      fill: #1D3739;
    };
    p {
      color: #1D3739;
    };
  }
`;

const StyledSubText = styled.a`
  text-transform: uppercase;
  font-size: 8px;
  letter-spacing: 0.32px;
  color: #1A1919;
  cursor: pointer;

  img {
    margin-left: 8px;
  }

  @media (max-width: 600px) {
    text-align: center;
  }
`;

export { StyledDiv, StyledLogo, StyleFirstRow, StyledButton, StyledSubText }
